import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import {
  inspectionJobReportIcon,
  createInspectionJob,
  omLogo,
  boschLogo,
  boschBanner,
  Bosch_Logo_Png,
  BOSCH_Logo
} from "../../assets/images";
// import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
// import Autocomplete from "@material-ui/lab/Autocomplete";
// import Chip from "@material-ui/core/Chip";
import moment from "moment";
import { OAuth as OAuthActions } from "../../js/actions";
import { useDispatch } from "react-redux";
import Table from "@material-ui/core/Table";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import TableBody from "@material-ui/core/TableBody";
import TableHead from "@material-ui/core/TableHead";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import CloudUploadOutlinedIcon from "@material-ui/icons/CloudUploadOutlined";
import { setSnackbar } from "../../js/reducers/snackbar";
import { useSelector } from "react-redux";
import Paper from "@material-ui/core/Paper";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import PhotoSizeSelectActualOutlinedIcon from "@material-ui/icons/PhotoSizeSelectActualOutlined";
import AttachFileOutlinedIcon from "@material-ui/icons/AttachFileOutlined";
import IconButton from "@material-ui/core/IconButton";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { useHistory } from "react-router-dom";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import * as _ from "lodash";
import ThumbDownAltOutlinedIcon from "@material-ui/icons/ThumbDownAltOutlined";
import ThumbUpOutlinedIcon from "@material-ui/icons/ThumbUpOutlined";
import Viewer from "react-viewer/dist/index.js";
import * as axios from "axios";
import { FileViewer } from "../../components/index";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import {
  Document,
  Font,
  Page,
  StyleSheet,
  Text,
  View,
  Image,
  PDFDownloadLink,
  BlobProvider,
  usePDF,
  pdf,
} from "@react-pdf/renderer";
import JSZip from "jszip";
import Bosch_Regular from "../../../src/assets/fonts/BoschSans-Regular-v5_003.ttf"

Font.register({
  family: 'BoschRegular',
  fonts: [
    { src: Bosch_Regular, fontWeight: 'normal' },  // Registering the regular font
    { src: Bosch_Regular, fontWeight: 'bold' },       // Registering the bold font
  ]
}) ;
//console.log("font:"+ BoschRegular);

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(4),
    height: "100%",
    backgroundColor: "white",
    border: "2px solid whitesmoke",
  },
  parentDiv: {
    width: "40vw",
    [theme.breakpoints.down("md")]: {
      width: "80vw",
    },
  },
  border: {
    margin: "1vh 0",
  },
  newTable: {
    borderBottom: "none",
    padding: "2px",
  },
  spanColor: {
    marginLeft: "10px",
    color: "gray",
  },
  parentDiv: {
    width: "100%",
    height: "100vh",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    backgroundColor: "transparent",
    position: "absolute",
    zIndex: "999",
  },
  ok: {
    backgroundColor: "#1abc9c",
    color: "#fff",
    width: "100px",
  },
  notOk: {
    backgroundColor: "#e74c3c",
    color: "#fff",
    width: "100px",
  },
  notYet: {
    backgroundColor: "#f1c40f",
    color: "#fff",
    width: "100px",
  },
  notAvailable: {
    backgroundColor: "#ff8900",
    color: "#fff",
    width: "100px",
  },
  textStyle: {
    fontWeight: 600,
  },
  
}));

const BORDER_COLOR = "#bfbfbf";
const BORDER_STYLE = "solid";
const COL1_WIDTH = 40;
const COLN_WIDTH = (100 - COL1_WIDTH) / 3;
const styles = StyleSheet.create({

  body: {
    marginTop: 10,
    marginBottom: 10,
    flexGrow: 1, // Ensures content grows between header and footer
  },
  body_chapter : {
    marginTop:'0', 
    paddingHorizontal:'10',
    marginTop: 10,
    marginBottom: 10,
    flexGrow: 1, // Ensures content grows between header and footer
  },
  
  header: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    // height: 60,  // Height of the header
    // justifyContent: 'space-between',
    // alignItems: 'center',
  },

  page: {

    // paddingTop: 70,   // Leave space for the header
    // paddingBottom: 70, // Leave space for the footer
    // paddingHorizontal: 2,
  },

  headerBanner:{
    width: "100%",
    height: 5,
    position: 'absolute',
    left: 0,
    top: 0,
  },

  title: {
    fontSize: 24,
    margin: 12,
    textAlign: "center",
    fontWeight: "bold",
    textDecoration: "underline",
  },
  subtitle: {
    fontSize: 16,
    marginVertical: 10,
    fontWeight: "bold",
    textDecoration: "underline",
  },
  page_listview: {
    paddingHorizontal:'0', 
    paddingTop:'40px', 
    paddingBottom:'35px'
},  
  subtitle_content: {
    fontSize: 16,
    fontWeight: "bold",
    marginVertical: 10,
    marginLeft: 10,
  },  
  text: {
    margin: 2,
    fontSize: 12,
    textAlign: "justify",
  },
  image: {
    marginVertical:5,
    marginHorizontal: 5,
    width: 'auto',
    // height: 'auto', // maintains aspect ratio
  },
  table: {
    display: "table",
    width: "auto",
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    marginTop: 10,
  },
 
  tableRow: {
    margin: "auto",
    flexDirection: "row",
  },
  tableCol1Header: {
    width: COL1_WIDTH + "%",
    backgroundColor: "#bfbfbf",
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableColHeader: {
    width: COLN_WIDTH + "%",
    backgroundColor: "#bfbfbf",
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCol1: {
    width: COL1_WIDTH + "%",
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCol: {
    width: COLN_WIDTH + "%",
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCellHeader: {
    margin: 5,
    fontSize: 12,
    fontWeight: 500,
  },
  tableCell: {
    margin: 5,
    fontSize: 10,
  },
  table1: {
    display: "table",
    width: "auto",
    marginBottom: "10px",
    marginLeft: "10px",
    marginRight: "10px",
  },
  tableRow1: {
    flexDirection: "row",
  },
  tableColCustom: {
    width: "20%",
    // backgroundColor:"#f0f0f0",
    // border: "1px solid #e4e4e4",
  },
  tableColCustomContent: {
    width: "80%",
    // border: "1px solid #e4e4e4",
  },

  /* new style*/
  tableColCustom_1: {
    width: "30%",
  },
  tableColCustomContent_1: {
    width: "70%",
  },

  header_1: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: 10,
    borderBottom: '1px solid #ddd', // Optional: adds a border below the header
    marginBottom: 20,
  },
 
  leftView_1: {
    flex: 1,
    // This ensures the left view takes all available space
  },
  rightView_1: {
    flex: 0, // Adjust this if you want to limit the logo's width
    width: 150, // Fixed width for logo view
  },


  //my style

  chapterContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '5',
    border: '1px solid #ddd',
    fontSize: 9
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
  },
  column: {
    display: 'flex',
    flexDirection: 'row',
    paddingVertical: '3',
    width: '50%', // Adjust if necessary
    paddingLeft: 5
  },
  label: {
    width: '50',
    color: '#4b4b4b',
    paddingVertical: '5',
    borderBottom:'1px solid #ddd',
    paddingLeft: 5,
    fontWeight: 'bold',
  },
  label_dot: {
    width: '10',
    color: '#4b4b4b',
    paddingVertical: '5',
    borderBottom:'1px solid #ddd',
    fontWeight: 'bold',
  },
  value: {
    flex: '1',
    flexWrap: 'wrap',
    paddingLeft: '5',
    paddingVertical: '5',
    borderBottom:'1px solid #ddd'
  },
  imageContainer: {
    display: 'flex',
    flexDirection: 'column',
    paddingVertical: '3',
    width: '100%',
  },
  imageRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    paddingLeft: '5',
    width: '100%',
  },
  imageSize: {
    width: '100%',
    margin: 5,
  },
  noImages: {
    color: 'red',
  },
  images_reference: {
    flexDirection: 'row', 
    flexWrap: 'wrap', 
    paddingLeft: '5', 
    width:'100%'
  },
  header_list: {
    position:'absolute',
    minHeight: 40,
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    borderBottom: '1px solid #ddd',
    // padding: '5px', // Added padding for better spacing
  },
  logo_1: {
    width:'150', // Logo will take the full width of its container
    height: 'auto', // Maintain aspect ratio
    marginLeft: 'auto',
  },
  headerBanner_list: {
    borderRight:'1px solid #ddd', 
    paddingRight:'30px',
    paddingTop:'30px', 
    width:'100%',
    display:'flex', 
    flexDirection:'column',
    alignItems: 'center',
    
  },
  title_list: {
    fontSize: 10,
    textAlign: 'left',
    paddingLeft: 10,
    fontWeight: 'bold',
    alignSelf:'center',
    marginTop:4
  },
      
  footer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    borderTop: '1px solid #ddd',
    // height: 60,
  },
  footer_text: {
    fontSize: 8,
    paddingLeft: 20,
    marginVertical: 10,
    textAlign:'left'
  },
 
  infoText: {
    fontSize: 8,
    textAlign: 'left',
    maxWidth: '60%',
    marginTop:5
  },
  title_head: {
    fontSize: 24,
    textAlign: 'left',
    paddingLeft: 30,
    paddingTop: 30,
    fontWeight: 'bold',
  },
  detailLabel: {
    color: '#808080',
  },
  pageNumber: {
    fontSize: 9,
    marginLeft: 'auto',
    paddingRight: 10,
  }


});

// Status enum for inspection topics
const TOPIC_STATUS = {
  PASS: "PASS",
  FAIL: "FAIL", 
  YET_TO_START: "YET_TO_START",
  NA: "NA"
};

// Status display text mapping
const STATUS_DISPLAY_TEXT = {
  [TOPIC_STATUS.PASS]: "Pass",
  [TOPIC_STATUS.FAIL]: "Fail",
  [TOPIC_STATUS.YET_TO_START]: "Yet to start",
  [TOPIC_STATUS.NA]: "Not Available"
};

const JobDetails = (props) => {
  let roleID;
  const dispatch = useDispatch();
  const history = useHistory();
  const [technicians, setTechnicians] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [chaptersData, setChaptersData] = useState([]);
  const classes = useStyles();
  const userRole = useSelector((state) => state.OAuth.roles);
  const [vin, setVin] = useState("");
  const [details, setDetails] = useState({
    jobId: "",
    status: "",
    inspectionDate: "",
    year: "",
    modelName: "",
    market: "",
    plantDetails: "",
    endDate: "",
  });
  const [expanded, setExpanded] = React.useState(false);
  const [exportOptions, setExportOptions] = useState(false);
  const [exportType, setExportType] = React.useState("excel");
  const [exportValue, setExportValue] = React.useState("all");

  const [imageVisible, setImageVisible] = useState(false);
  const [inspectImages, setInspectImages] = useState({});
  const [referencePdf, setReferencePdf] = useState();
  const [onPdfClick, setOnPdfClick] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    if (panel !== "all") {
      setExpanded(isExpanded ? panel : false);
    } else {
      setExpanded(!expanded);
    }
  };

  // function blobToFile(theBlob, fileName) {
  //   //A Blob() is almost a File() - it's just missing the two properties below which we will add
  //   theBlob.lastModifiedDate = new Date();
  //   theBlob.name = fileName;
  //   return theBlob;
  // }

  if (props && props.location && props.location.rowdata === undefined) {
    history.replace("/inspection-job-report");
  }
  const [filterStatus, setFilterStatus] = useState("All");
 

  if (exportLoading) {
    document.body.classList.add("set-loading-indicator");
  }
  else{
    document.body.classList.remove("set-loading-indicator");
  }
  useEffect(async () => {
        
    if (props && props.location && props.location.rowdata !== undefined) {
      await dispatch(OAuthActions.getRole()).then(function (roles) {
        if (roles) {
          roleID = roles.find((c) => c.name === "Technician").uid;
        }
      });
      let technicianList = {};
      try {
        await dispatch(
          OAuthActions.getJobById(props.location.rowdata.jobId)
        ).then(function (details) {
          // Add null check for details and jobBasicDetailsDto
          if (details && details.jobBasicDetailsDto) {
            technicianList = details.jobBasicDetailsDto.technicianList;
            setVin(details.vin ? details.vin : "No Vin Added");
            setDetails(details.jobBasicDetailsDto);

            // Add null check for technicianList before using reduce
            if (technicianList && Array.isArray(technicianList) && technicianList.length > 0) {
              const stringData = technicianList.reduce((result, item, index) => {
                return index === 0
                  ? `${result}${item.firstName} ${item.lastName}`
                  : `${result},${item.firstName} ${item.lastName}`;
              }, "");
              setTechnicians(stringData);
            } else {
              setTechnicians("No Technicians Assigned");
            }
            
            setChapters(details.chapters);
            //console.log("details.chapters in useEff: ",details);
            const chapterdeep = _.cloneDeep(details.chapters);
            setChaptersData(chapterdeep);
          } else {
            console.error("Invalid API response structure");
            setTechnicians("Error loading technicians");
          }
        });
      } catch (error) {
        console.error("Error fetching job details:", error);
        setTechnicians("Error loading technicians");
      }
    }

  }, []);

  const getImageView = async (details) => {
    let allImageUrls = details.images;
    let images = [];
    if (allImageUrls && allImageUrls !== null)
      for (const image of allImageUrls) {
        let axiosData = await axios({
          url: image,
          method: "GET",
          responseType: "blob",
        })
          .then((response) => {
            if (response.data !== null) {
              if (response.data) {
                const file = new File([response.data], {
                  type: "image/jpeg",
                });
                var imageUrl = URL.createObjectURL(file);
               // console.log("Image URL created"+ imageUrl);
                return imageUrl;
              }
            }
          })
          .catch(function (err) {
            //for any CORS/Error cases
          });
        images.push({ src: axiosData });
      }
    if (images.length > 0) {
      setInspectImages(images);
      setImageVisible(true);
    } else
      dispatch(setSnackbar(true, "info", "No Images Present under this topic"));
  };
  const getPDFView = (details) => {
    if (details?._links?.manualLink?.href) {
      const pdfUrl = details._links.manualLink.href;
      console.log("📄 Original PDF URL:", pdfUrl);
      
      // Analyze the URL structure
      const urlObj = new URL(pdfUrl);
      const filePath = urlObj.searchParams.get('filePath');
      console.log("📄 Extracted filePath parameter:", filePath);
      
      // Try to decode the file path and show different encoding levels
      try {
        const singleDecoded = decodeURIComponent(filePath);
        console.log("📄 Single decoded filePath:", singleDecoded);
        
        const doubleDecoded = decodeURIComponent(singleDecoded);
        console.log("📄 Double decoded filePath:", doubleDecoded);
        
        // Create corrected URL with single-encoded path
        const correctedUrl = `${urlObj.origin}${urlObj.pathname}?filePath=${encodeURIComponent(doubleDecoded)}`;
        console.log("📄 Corrected URL (single-encoded):", correctedUrl);
        
      } catch (decodeError) {
        console.error("📄 Error decoding filePath:", decodeError);
      }
      
      axios({
        url: pdfUrl,
        method: "GET",
        responseType: "blob",
        timeout: 30000, // 30 second timeout
        headers: {
          'Accept': 'application/pdf,*/*'
        }
      })
        .then((response) => {
          console.log("📄 PDF fetch successful with original URL:", response);
          if (response.data && response.data.size > 0) {
            const file = new File([response.data], "reference_manual.pdf", {
              type: "application/pdf",
            });

            setReferencePdf(file);
            setOnPdfClick(true);
          } else {
            console.error("PDF response is empty");
            dispatch(setSnackbar(true, "error", "PDF file is empty or corrupted"));
          }
        })
        .catch((error) => {
          console.error("📄 First attempt failed with original URL:", error);
          
          // Try with corrected URL (fix double encoding)
          const urlObj = new URL(pdfUrl);
          const filePath = urlObj.searchParams.get('filePath');
          
          try {
            const singleDecoded = decodeURIComponent(filePath);
            const doubleDecoded = decodeURIComponent(singleDecoded);
            const correctedUrl = `${urlObj.origin}${urlObj.pathname}?filePath=${encodeURIComponent(doubleDecoded)}`;
            
            console.log("📄 Trying corrected URL:", correctedUrl);
            
            return axios({
              url: correctedUrl,
              method: "GET", 
              responseType: "blob",
              timeout: 30000,
              headers: {
                'Accept': 'application/pdf,*/*'
              }
            })
            .then((response) => {
              console.log("📄 PDF fetch successful with corrected URL:", response);
              if (response.data && response.data.size > 0) {
                const file = new File([response.data], "reference_manual.pdf", {
                  type: "application/pdf",
                });

                setReferencePdf(file);
                setOnPdfClick(true);
              } else {
                console.error("PDF response is empty");
                dispatch(setSnackbar(true, "error", "PDF file is empty or corrupted"));
              }
            });
          } catch (decodeError) {
            console.error("📄 Error creating corrected URL:", decodeError);
            throw error; // Re-throw original error
          }
        })
        .catch((finalError) => {
          console.error("📄 All attempts failed:", finalError);
          const errorMessage = finalError.response?.status === 404 
            ? "PDF file not found" 
            : "Failed to load PDF reference file. Please check your internet connection.";
          dispatch(setSnackbar(true, "error", `Error loading PDF: ${errorMessage}`));
        });
    } else {
      dispatch(setSnackbar(true, "info", "No reference PDF available for this topic"));
    }
  };

  // Helper function to determine topic status based on result value
  const getTopicStatus = (result) => {
    if (result === null || result === "NULL" || result === undefined) {
      return TOPIC_STATUS.YET_TO_START;
    }
    if (result === true || result === "true") {
      return TOPIC_STATUS.PASS;
    }
    if (result === false || result === "false") {
      return TOPIC_STATUS.FAIL;
    }
    if (result === "NA") {
      return TOPIC_STATUS.NA;
    }
    // Default fallback for any unknown values
    return TOPIC_STATUS.YET_TO_START;
  };

  // Helper function to get status text for display
  const getStatusText = (result) => {
    const status = getTopicStatus(result);
    return STATUS_DISPLAY_TEXT[status] || STATUS_DISPLAY_TEXT[TOPIC_STATUS.YET_TO_START];
  };

  // Helper function to check if topic has failed
  const isTopicFailed = (result) => {
    return getTopicStatus(result) === TOPIC_STATUS.FAIL;
  };

  // Helper function to check if topic has passed
  const isTopicPassed = (result) => {
    return getTopicStatus(result) === TOPIC_STATUS.PASS;
  };

  const getImages = async (chapterImages) => {
    if (!chapterImages) return [];
  
    const imagePromises = chapterImages.map(async (image) => {
      const url = String(image);
      const imagePath = url.substring(url.lastIndexOf('/') + 1, url.lastIndexOf('.jpeg'));
  
      try {
        const response = await axios.get(image, { responseType: 'blob' });
        if (response.data) {
          const file = new File([response.data], { type: 'image/jpeg' });
          const imageUrl = URL.createObjectURL(file);
          return { src: imageUrl, filename: imagePath };
        }
      } catch (error) {
        console.error(`Error fetching image from ${url}:`, error);
        return { src: `Error: ${error.message}`, filename: imagePath };
      }
    });
  
    return Promise.all(imagePromises);
  };

  //simplify this function to get better performance
  const NewDocument = async () => {
    const allChapters = await Promise.all(
      chapters.map(async (chapter) => {
        const chapterName = chapter.name;
        const topics = await Promise.all(
          chapter.topics.map(async (topic) => {
            const topicData = {
              Chapter: chapterName,
              topic: topic.name,
              remarks: topic.remarks,
              topicImage: [],
              results: getStatusText(topic.result),
            };
  
            if (topic.images) {
              topicData.topicImage = await getImages(topic.images);
            }
  
            if ((exportValue === "failed" && isTopicFailed(topic.result)) || exportValue === "all") {
              return topicData;
            }
  
            return null;
          })
        );
  
        return topics.filter((topic) => topic !== null);
      })
    );
  
    const flattenedChapters = allChapters.flat();
  
    if (flattenedChapters.length === 0) {
      dispatch(setSnackbar(true, "info", "No data present in the file to export"));
      setExportOptions(false);
      return null;
    }
  
    setExportOptions(false);
  
    return (
      <Document>
        <Page style={styles.page}>
          {/* header1 starts */}
          <View style={styles.header} fixed>
            <Image style={styles.headerBanner} src={boschBanner} />
            <View style={styles.headerBanner_list}>
              <Image src={Bosch_Logo_Png} style={styles.logo_1} />
              <Text style={styles.title_head}>Owners Manual Inspection Report</Text>
            </View>
          </View>
          {/* header Ends */}
          <View style={{ justifyContent: "center", alignItems: "center", top: "25%" }}>
            <Text style={styles.subtitle}>Job Details:</Text>
            <View style={styles.table}>
              <View style={styles.tableRow}>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>Job Id :</Text>
                </View>
                <View style={styles.tableCol1}>
                  <Text style={styles.tableCell}>{details.jobId}</Text>
                </View>
              </View>
              {/* technicians */}
              <View style={styles.tableRow}>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>Technicians :</Text>
                </View>
                <View style={styles.tableCol1}>
                  <Text style={styles.tableCell}>{technicians}</Text>
                </View>
              </View>
              {/* VIN */}
              <View style={styles.tableRow}>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>VIN Number :</Text>
                </View>
                <View style={styles.tableCol1}>
                  <Text style={styles.tableCell}>{vin}</Text>
                </View>
              </View>
              {/* Year */}
              <View style={styles.tableRow}>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>Year : </Text>
                </View>
                <View style={styles.tableCol1}>
                  <Text style={styles.tableCell}>{details.year}</Text>
                </View>
              </View>
              {/* Model */}
              <View style={styles.tableRow}>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>Model : </Text>
                </View>
                <View style={styles.tableCol1}>
                  <Text style={styles.tableCell}>{details.modelName}</Text>
                </View>
              </View>
              {/* Market */}
              <View style={styles.tableRow}>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>Market : </Text>
                </View>
                <View style={styles.tableCol1}>
                  <Text style={styles.tableCell}>{details.market}</Text>
                </View>
              </View>
              {/* Plant */}
              <View style={styles.tableRow}>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>Plant : </Text>
                </View>
                <View style={styles.tableCol1}>
                  <Text style={styles.tableCell}>{details.plantDetails}</Text>
                </View>
              </View>
              {/* Inspection Start Date */}
              <View style={styles.tableRow}>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>Inspection Start Date :</Text>
                </View>
                <View style={styles.tableCol1}>
                  <Text style={styles.tableCell}>
                    {details.inspectionDate ? moment(details.inspectionDate).format("DD/MM/YYYY") : ""}
                  </Text>
                </View>
              </View>
              {/* Inspection End Date */}
              <View style={styles.tableRow}>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>Inspection End Date :</Text>
                </View>
                <View style={styles.tableCol1}>
                  <Text style={styles.tableCell}>
                    {details.endDate ? moment(details.endDate).format("DD/MM/YYYY") : ""}
                  </Text>
                </View>
              </View>
            </View>
          </View>
        </Page>
  
        <Page style={[styles.page_listview]}>
          {/* header-2 starts */}
          <View style={styles.header_list} fixed>
            <Image style={styles.headerBanner} src={boschBanner} />
            <Text style={[styles.title_list, { fontWeight: 'bold' }]}>Inspection Job Report | </Text>
            <View style={styles.infoText}>
              <Text>
                {details.modelName} - {details.year} | Market: {details.market} | {details.plantDetails} : {details.inspectionDate
                  ? moment(details.inspectionDate).format("DD/MM/YYYY")
                  : ""} - {details.endDate
                    ? moment(details.endDate).format("DD/MM/YYYY")
                    : ""}
              </Text>
            </View>
            <Text
              style={styles.pageNumber}
              render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
            />
          </View>
          {/* header-2 ends */}
  
          {/* content-2 starts */}
          <View style={[styles.body_chapter]}>
            <Text style={[styles.subtitle_content]}>Vehicle Inspection Details:</Text>
            
            {flattenedChapters.map((row, index) => {
              let errorCount = 0;
              if (Array.isArray(row.topicImage)) {
                row.topicImage.forEach(image => {
                  if (image.src.startsWith('Error')) {
                    errorCount++;
                  }
                });
              }
            let imagesLabelDisplayed = false;
	          let errorLabelDisplayed = false;

            return (
              <View key={index} style={styles.chapterContainer}>
                <View style={styles.row}>
                  <Text style={styles.label}>Chapter </Text>
                  <Text style={styles.label_dot}>:</Text>
                  <Text style={styles.value}>{row.Chapter}</Text>
                </View>
                <View style={styles.row}>
                  <Text style={styles.label}>Topic </Text>
                  <Text style={styles.label_dot}>:</Text>
                  <Text style={styles.value}>{row.topic}</Text>
                </View>
                <View style={styles.row}>
                  <Text style={styles.label}>Results </Text>
                  <Text style={styles.label_dot}>:</Text>
                  <Text style={[styles.value, {
                    color: row.results === "Pass" ? 'green' :
                      row.results === "Fail" ? 'red' :
                      row.results === "Not Available" ? '#ff8900' : 'black'
                  }]}>
                    {row.results}
                  </Text>
                </View>
                <View style={styles.row}>
                  <Text style={styles.label}>Remarks </Text>
                  <Text style={styles.label_dot}>:</Text>
                  <Text style={styles.value}>{row.remarks}</Text>
                </View>
                {row.topicImage && row.topicImage.length > 0 ? (
                  <View>
                   {(() => {
  let errorMessages = [];
  return row.topicImage.map((image, i) => {
    if (image.src.startsWith('Error')) {
      errorMessages.push(`${image.src} (${image.filename})`);
    }
    return (
      <View key={`${index}-${i}`}>
        {image.src.startsWith('Error') ? (
          <View style={styles.row}>
            {!imagesLabelDisplayed && (
              <>
                <Text style={[styles.label, { borderBottom: '0px' }]}>
                  Images 
                </Text>
                <Text style={[styles.label_dot, { borderBottom: '0px' }]}>:</Text>
              </>
            )}
            <Text style={[styles.value, { borderBottom: '0px', color: 'red' }]}>
              {image.src} ({image.filename})
            </Text>
          </View>
        ) : (
          <View style={styles.imageContainer}>
            {!imagesLabelDisplayed && (
              <Text style={[styles.label, { borderBottom: '0px' }]}>
                Images 
              </Text>
            )}
            <View style={styles.images_reference}>
              <Image
                style={[styles.image, { width: '100%' }]}
                src={image.src}
              />
            </View>
          </View>
        )}
        {imagesLabelDisplayed = true}
      </View>
    );
  });
})()}
                  </View>
                ) : (
                  <View style={styles.row}>
                    <Text style={[styles.label, { borderBottom: '0px' }]}>Images </Text>
                    <Text style={[styles.label_dot, { borderBottom: '0px' }]}>:</Text>
                    <Text style={[styles.value, { borderBottom: '0px' }]}>Image not available</Text>
                  </View>
                )}
              </View>
            );
          })}
        </View>
        {/* content-2 end */}

        {/* footer2 start */}
        <View style={[styles.footer]} fixed>
          <Text style={styles.footer_text}>
            Job id: {details.jobId} | Technician: {technicians}
          </Text>
        </View>
        {/* footer2 end */}
      </Page>
    </Document>
  );
};  

  
  const exportToPDF = async () => {
    setExportLoading(true);
    const pdfDocument = await NewDocument();
    if (pdfDocument) {
      const pdfBlob = await pdf(pdfDocument).toBlob();
      FileSaver.saveAs(pdfBlob, `${details.jobId}.pdf`);
    }
    setExportLoading(false);
  };
   
  const exportToCSVBlob = async (apiData) => {
    console.log(apiData);
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
  
    // Create the worksheet using AOA format
    const wsData = [
      ['Chapter', 'Topic', 'Remarks', 'Results','Topic Images'], // Header row
      ...apiData.map((item) => {
        // Split and clean the topicImage string
        const images = item.topicImage ? item.topicImage.split(',').map(img => img.trim()).filter(Boolean) : [];
  
        // Create a single row for each topic
        const row = [
          item.Chapter,
          item.topic,
          item.remarks,
          item.results,
          images.length > 0 ? { f: `HYPERLINK("./images/${images[0]}", "${images[0]}")` } : '-', // First image or '-'
        ];
  
      // Add additional columns for each additional image or error message
      for (let i = 1; i < images.length; i++) {
        if (images[i].startsWith('Error')) {
          const errorMessage = images[i];
          const imageName = images[i].split('Error: ')[1];
          row.push({ v: `Error: ${errorMessage}`});//(${imageName}) Add error message with red font color
        } else {
          row.push({ f: `HYPERLINK("./images/${images[i]}", "${images[i]}")` });
        }
      }
  
        return row;
      })
    ];
  
    // Create a new workbook and append the worksheet
    const ws = XLSX.utils.aoa_to_sheet(wsData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'data');
  
    // Write the workbook to a Blob and return it
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    return new Blob([excelBuffer], { type: fileType }); // Return Blob instead of saving directly
  };

  const exportToExcel = async () => {
    setExportLoading(true);
    const allChapters = [];
    const imagesZip = new JSZip();
    const mainZip = new JSZip();
    let imagesAdded = false;
  
    const chapterPromises = chapters.map(async (chapter) => {
      const chapterName = chapter.name;
      const topicPromises = chapter.topics.map(async (topic) => {
        const topicData = {
          Chapter: chapterName,
          topic: topic.name,
          remarks: topic.remarks,
          topicImage: topic.images,
          results: getStatusText(topic.result),
        };
  
        if ((exportValue === "failed" && isTopicFailed(topic.result)) || exportValue === "all") {
          if (topic.images) {
            const topicImages = await getImages(topic.images);
            const imageSrcs = await Promise.all(topicImages.map(async (image) => {
              const blobUrl = image.src;
              const imagePath = image.filename;
  
              if (blobUrl && blobUrl.startsWith('blob:')) {
                try {
                  const response = await fetch(blobUrl);
                  const blob = await response.blob();
                  const imageName = `${imagePath}.jpg`;
                  imagesZip.file(imageName, blob);
		              imagesAdded = true;
                  return imageName;
                } catch (error) {
                  console.error(`Error fetching image from ${blobUrl}:`, error);
                  return `Error: ${error.message}`;
                }
              } else if (blobUrl.startsWith('Error')) {
              return `${blobUrl} (${imagePath})`;
            }	      
	      else {
                console.warn(`Invalid or undefined Blob URL`);
                return imagePath;
              }
            }));
            topicData["topicImage"] = imageSrcs.join(', ');
          }
          allChapters.push(topicData);
        }
      });
      await Promise.all(topicPromises);
    });
  
    await Promise.all(chapterPromises);
  
    if (allChapters.length > 0) {
      const csvBlob = await exportToCSVBlob(allChapters);
      mainZip.file(`${details.jobId}.xlsx`, csvBlob);
    if (imagesAdded) {
      const imagesZipContent = await imagesZip.generateAsync({ type: "blob" });
      mainZip.file("images.zip", imagesZipContent);
    }
      const mainZipContent = await mainZip.generateAsync({ type: "blob" });
      FileSaver.saveAs(mainZipContent, `${details.jobId}.zip`);
    } else {
      dispatch(setSnackbar(true, "info", "No data present in the file to export"));
    }
  
    setExportLoading(false);
  };

  const exportData = async () => {
    setExportOptions(false);
    setExportLoading(true);
  
    try {
      if (exportType === "pdf") {
        await exportToPDF();
      } else if (exportType === "excel") {
        await exportToExcel();
      } else {
        console.error("Invalid export type specified");
      }
    } catch (error) {
      console.error("Error exporting data:", error);
    } finally {
      setExportLoading(false);
    }
  };

  const renderAccordion = (details, index) => {
    // console.log("renderAccordion", chapters);
    chapters.forEach((element) => {
      let inspectionImages = element.topics[0].images;
      if (inspectionImages !== null)
        inspectionImages.forEach((image) => {
          //console.log("iMages when renderAccordion", image);
        });
    });
    let dataSet = details.topics;
    return (
      <Accordion
        key={index}
        expanded={expanded === `panel${index}` || expanded === true}
        onChange={handleChange(`panel${index}`)}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>{details.name}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Topics</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Remarks</TableCell>
                  <TableCell>Pictures</TableCell>
                  <TableCell>Reference</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {dataSet.length > 0 ? (
                  dataSet.map(function (row, i) {
                    return (
                      <TableRow key={row.name}>
                        <TableCell>{row.name}</TableCell>
                        {
                          <TableCell>
                            {(() => {
                              const status = getTopicStatus(row.result);
                              
                              if (status === TOPIC_STATUS.PASS) {
                                return (
                                  <Grid
                                    container
                                    direction="row"
                                    justify="center"
                                    alignItems="center"
                                    spacing={1}
                                    className={classes.ok}
                                  >
                                    <Grid item>
                                      <ThumbUpOutlinedIcon />
                                    </Grid>
                                    <Grid item>PASS</Grid>
                                  </Grid>
                                );
                              } else if (status === TOPIC_STATUS.FAIL) {
                                return (
                                  <Grid
                                    container
                                    direction="row"
                                    justify="center"
                                    alignItems="center"
                                    spacing={1}
                                    className={classes.notOk}
                                  >
                                    <Grid item>
                                      <ThumbDownAltOutlinedIcon />
                                    </Grid>
                                    <Grid item>FAIL</Grid>
                                  </Grid>
                                );
                              } else if (status === TOPIC_STATUS.NA) {
                                return (
                                  <Grid
                                    container
                                    direction="row"
                                    justify="center"
                                    alignItems="center"
                                    spacing={1}
                                    className={classes.notAvailable}
                                  >
                                    <Grid item>Not Available</Grid>
                                  </Grid>
                                );
                              } else {
                                // YET_TO_START or unknown
                                return (
                                  <Grid
                                    container
                                    direction="row"
                                    justify="center"
                                    alignItems="center"
                                    spacing={1}
                                    className={classes.notYet}
                                  >
                                    <Grid item>Yet To Start</Grid>
                                  </Grid>
                                );
                              }
                            })()}
                          </TableCell>
                        }
                        <TableCell
                          className={!row.remarks ? classes.textStyle : null}
                        >
                          {row.remarks ? row.remarks : "- - - - -"}
                        </TableCell>
                        <TableCell>
                          <IconButton
                            color="primary"
                            aria-label="upload picture"
                            component="span"
                            onClick={() => {
                              getImageView(row);
                            }}
                          >
                            <PhotoSizeSelectActualOutlinedIcon />
                          </IconButton>
                        </TableCell>
                        <TableCell>
                          <IconButton
                            color="primary"
                            aria-label="upload picture"
                            component="span"
                            onClick={() => {
                              getPDFView(row);
                              // setOnPdfClick(true);
                            }}
                          >
                            <AttachFileOutlinedIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableCell
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    No Record to show
                  </TableCell>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </AccordionDetails>
      </Accordion>
    );
  };

  return (
    <>
      <div>
        <Dialog open={exportOptions} onClose={() => setExportOptions(false)}>
          <DialogTitle
            id="export-dialog-title"
            style={{ fontWeight: "bold", color: "rgb(0, 86, 145)" }}
          >
            Export Options
          </DialogTitle>
          <DialogContent dividers>
            <Grid
              container
              direction="column"
              justify="space-around"
              alignItems="flex-start"
            >
              <FormControl component="fieldset">
                <FormLabel component="legend">
                  Type of document you want to export:
                </FormLabel>
                <RadioGroup
                  value={exportType}
                  onChange={(event) => setExportType(event.target.value)}
                >
                  <FormControlLabel
                    value="excel"
                    control={<Radio />}
                    label="Excel"
                  />
                  <FormControlLabel
                    value="pdf"
                    control={<Radio />}
                    label="PDF"
                  />
                </RadioGroup>
              </FormControl>
              <FormControl component="fieldset">
                <FormLabel component="legend">
                  Show all or only failed topics:
                </FormLabel>
                <RadioGroup
                  value={exportValue}
                  onChange={(event) => setExportValue(event.target.value)}
                >
                  <FormControlLabel
                    value="all"
                    control={<Radio />}
                    label="Show All"
                  />
                  <FormControlLabel
                    value="failed"
                    control={<Radio />}
                    label="Only Failed"
                  />
                </RadioGroup>
              </FormControl>
              
            </Grid>
            
          </DialogContent>
          <DialogActions>
            <Button
              autoFocus
              onClick={() => setExportOptions(false)}
              variant="outlined"
            >
              Cancel
            </Button>
            <Button variant="contained" onClick={exportData}>
              Ok
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={onPdfClick}
          onClose={() => setOnPdfClick(false)}
          maxWidth={"lg"}
          fullWidth={true}
        >
          <FileViewer pdfFile={referencePdf} />
        </Dialog>
        <Viewer
          styles={{ zIndex: 99999 }}
          visible={imageVisible}
          onClose={() => {
            setImageVisible(false);
          }}
          images={inspectImages}
        />
      </div>
      <div className={classes.root}>
        <Grid container>
          <Grid container direction="row" justify="space-between">
            <Grid item sm={10}>
              <div style={{ display: "flex" }}>
                <img
                  src={inspectionJobReportIcon}
                  style={{ height: "2rem", margin: "0 1rem" }}
                />
                <Typography variant="h2">
                  <strong>Job Details:</strong>
                </Typography>
              </div>
              <hr className={classes.border} color="whitesmoke" />
              <br />
            </Grid>
            <Grid item>
            
              <Button
                size="small"
                variant="contained"
                startIcon={<CloudUploadOutlinedIcon />}
                onClick={() => setExportOptions(true)}
              >
                Export
              </Button>

            </Grid>
          </Grid>
        </Grid>
        <Grid container direction="row" justify="space-around" spacing={2}>
          <Grid item xs={12} sm={2}>
            <img src={createInspectionJob} style={{ height: "16vh" }} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <h1 style={{ color: "#005691", fontSize: "15px" }}>Job Details</h1>
            <TableContainer>
              <Table aria-label="simple table">
                <TableBody>
                  <TableRow key="1">
                    <TableCell
                      component="th"
                      scope="row"
                      className={classes.newTable}
                    >
                      Job Id
                    </TableCell>
                    <TableCell className={classes.newTable} align="left">
                      {details.jobId}
                    </TableCell>
                  </TableRow>
                  <TableRow key="2">
                    <TableCell
                      component="th"
                      scope="row"
                      className={classes.newTable}
                    >
                      Technicians
                    </TableCell>
                    <TableCell className={classes.newTable} align="left">
                      <Grid container direction="row">
                        {technicians}
                      </Grid>
                    </TableCell>
                  </TableRow>
                  <TableRow key="3">
                    <TableCell
                      component="th"
                      scope="row"
                      className={classes.newTable}
                    >
                      VIN
                    </TableCell>
                    <TableCell className={classes.newTable} align="left">
                      {vin}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid item xs={12} sm={4}></Grid>
        </Grid>
        <Grid
          direction="row"
          container
          style={{ backgroundColor: "whitesmoke", marginTop: "4px" }}
        >
          <h1 style={{ color: "#005691", fontSize: "15px" }}>More Details....</h1>
        </Grid>
        <Grid container>
          <Grid item sm={12}>
            <TableContainer>
              <Table aria-label="simple table">
                <TableBody>
                  <TableRow key="1">
                    <TableCell
                      className={classes.newTable}
                      align="left"
                      style={{ borderRight: "1px solid gray", padding: "1rem" }}
                    >
                      <span className={classes.spanColor}>Model: </span>
                      {details.modelName}
                    </TableCell>
                    <TableCell
                      className={classes.newTable}
                      align="left"
                      style={{ borderRight: "1px solid gray", padding: "1rem" }}
                    >
                      <span className={classes.spanColor}>Market: </span>
                      {details.market}
                    </TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      className={classes.newTable}
                      style={{
                        borderRight: "1px solid gray",
                        padding: "1rem",
                      }}
                    >
                      <span className={classes.spanColor}>Year: </span>
                      {details.year}
                    </TableCell>
                    <TableCell className={classes.newTable} align="left">
                      <span className={classes.spanColor}>Plant: </span>
                      {details.plantDetails}
                    </TableCell>
                  </TableRow>
                  <TableRow key="2">
                    <TableCell
                      component="th"
                      scope="row"
                      className={classes.newTable}
                      style={{ borderRight: "1px solid gray", padding: "1rem" }}
                    >
                      <span className={classes.spanColor}>Start: </span>
                      {details.inspectionDate
                        ? moment(details.inspectionDate).format("DD/MM/YYYY")
                        : ""}
                    </TableCell>
                    <TableCell
                      className={classes.newTable}
                      align="left"
                      style={{ borderRight: "1px solid gray", padding: "1rem" }}
                    >
                      <span className={classes.spanColor}>End: </span>
                      {details.endDate
                        ? moment(details.endDate).format("DD/MM/YYYY")
                        : ""}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
        <Grid
          direction="row"
          justify="space-between"
          container
          style={{ backgroundColor: "whitesmoke", marginTop: "4px" }}
        >
          <h1 style={{ color: "#005691", fontSize: "15px", marginTop: "10px" }}>
            Chapter Information
          </h1>
          <Button onClick={handleChange("all")}>
            {expanded === true ? "Collapse All" : "Expand All"}
          </Button>
          <Grid style={{ marginRight: "10px" }}>
            <RadioGroup
              row
              aria-label="position"
              name="position"
              value={filterStatus}
            >
              <FormControlLabel
                value="notOk"
                control={<Radio color="primary" />}
                label="View Failed "
                labelPlacement="start"
                onClick={() => {
                  setFilterStatus("notOk");
                  const data = _.cloneDeep(chapters);
                  data.forEach((a) => {
                    a.topics = a.topics.filter((g) => isTopicFailed(g.result));
                  });
                  // console.log(data);
                  let finalData = [];
                  finalData = data.filter((a) => a.topics.length !== 0);
                  setChaptersData(finalData);
                }}
              />
              <FormControlLabel
                value="All"
                control={<Radio color="primary" />}
                label="View All"
                labelPlacement="start"
                onClick={() => {
                  setFilterStatus("All");
                  const data = _.cloneDeep(chapters);
                  setChaptersData(data);
                }}
              />
            </RadioGroup>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          {chaptersData.length !== 0 ? (
            chaptersData.map(renderAccordion)
          ) : (
            <Grid
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "1rem",
              }}
            >
              No Records to Display
            </Grid>
          )}
          {/* <MaterialTable
            data={chapters}
            columns={[
              { title: "Chapter", field: "chapter" },
              { title: "Topic", field: "topic" },
              { title: "Status", field: "result" },
              { title: "Remarks", field: "type" },
              { title: "Pictures", field: "pictures" },
              { title: "Reference", field: "reference" },
            ]}
            // parentChildData={(row, rows) =>
            //   rows.find((a) => a.id === row.parentId)
            // }
            options={{
              showTitle: false,
              showFirstLastPageButtons: false,
              rowStyle: (rowData) => ({
                backgroundColor: !rowData.parentOnly ? "#EEE" : "white",
              }),
            }}
          /> */}
        </Grid>
      </div>
    </>
  );
};
export default JobDetails;
